import {
  TwoFactorTOTPForm
} from "./chunk-RVXJZR3B.mjs";
import {
  LoadingButton_default
} from "./chunk-5UPEKN6R.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";

// src/internal/components/two-factor-panel/two-factor-disabled-panel.tsx
import * as React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuthContext } from "@clara/auth";
import { Translation, useT } from "@clara/locale";
import { Banner } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
function SidePanel(props) {
  const { t } = useT(["auth", "common"]);
  const { twoFactorAuthentication: twofactor } = useAuthContext();
  React.useEffect(() => {
    var _a;
    if (!twofactor.enabled)
      (_a = props.prev) == null ? void 0 : _a.call(props);
  }, [twofactor.enabled, props.prev]);
  return /* @__PURE__ */ jsxs(Stack, { spacing: 2, width: "100%", children: [
    /* @__PURE__ */ jsxs(Stack, { spacing: 1, width: "100%", children: [
      /* @__PURE__ */ jsx(Typography, { variant: "body1.bold", children: t("fields.recovery.label") }),
      /* @__PURE__ */ jsx(Typography, { variant: "body1", children: t("twofa_disabled_details") })
    ] }),
    /* @__PURE__ */ jsx(
      TwoFactorTOTPForm,
      {
        challenge: "both",
        loading: twofactor.validating.loading || twofactor.updating.loading,
        error: twofactor.validating.error || twofactor.updating.error,
        onSubmit: twofactor.deactivate,
        children: ({ isValid }) => /* @__PURE__ */ jsx(Stack, { spacing: 3, children: isValid && /* @__PURE__ */ jsx(Banner, { status: "info", children: t("twofactor.disabled.disclaimer") }) })
      }
    )
  ] });
}
var TwoFaDisablePanelFooter = () => {
  var _a, _b;
  const { panelFormData } = useAuthContext();
  const { t } = useT("auth");
  return /* @__PURE__ */ jsx(
    LoadingButton_default,
    {
      type: "submit",
      form: panelFormData == null ? void 0 : panelFormData.formId,
      variant: "contained",
      loading: (_a = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _a.loading,
      disabled: !((_b = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _b.isValid),
      children: t("twofactor.disabled.submit")
    }
  );
};
var TwofactorDisabledSidePanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx(SidePanel, {}),
        header: /* @__PURE__ */ jsx(Translation, { ns: "auth", children: (t) => /* @__PURE__ */ jsx(
          SidePanelHeader,
          {
            variant: "alternate",
            headline: t("twofa_disabled_headline"),
            tagline: t("twofa_disabled_tagline")
          }
        ) }),
        footer: /* @__PURE__ */ jsx(TwoFaDisablePanelFooter, {})
      }
    ]
  }
];
var two_factor_disabled_panel_default = TwofactorDisabledSidePanel;

export {
  two_factor_disabled_panel_default
};
